export default "__VITE_ASSET__BZQckF1m__"